<template>
  <div class="guest-page guest-page-body">
    <Toast position="top-right"></Toast>
    <CapGuestHeader/>

    <main class="main">
      <div class="container">
        <router-view/>
      </div>
    </main>

    <router-view name="submain"/>

    <CapGuestFooter/>
  </div>
</template>

<script>
import CapGuestFooter from '@/views/layouts/guest/CapGuestFooter';
import CapGuestHeader from '@/views/layouts/guest/CapGuestHeader';
import Toast from "primevue/toast";

export default {
  name: 'GuestContainer',
  components: {Toast, CapGuestHeader, CapGuestFooter},
};
</script>

<style scoped lang="less">
.guest-page {
  min-height: 100vh;
  background: #f5f9fc;
}
</style>
